<template>
  <div>
    <div style="margin-top:120px">
        <v-layout row wrap >
            <v-flex xs12>
                <v-card class="form-container" flat style="border:1px solid">
                    <h3 style="text-align:center">My Orders</h3>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          flat
          v-model="search"
          append-icon="search"
          color="black"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table hide-actions :headers="tableHeader" :items="list" :search="search">
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left">{{ props.item.orderCode }}</td>
          <td class="text-xs-left">{{ props.item.date }}</td>
          <td class="text-xs-left">{{ props.item.totalPrice.toFixed(2) }}</td>
          <td class="text-xs-left">
            <span v-if="props.item.packed==true && props.item.shipped==false && props.item.cancelled==false" style="font-size:10px;padding:3px;background-color:green;border-radius:5px;color:white">Packed</span>
            <span v-if="props.item.packed==false && props.item.ordered==true && props.item.cancelled==false" style="font-size:10px;padding:3px;background-color:#2196F3;border-radius:5px;color:white">Ordered</span>
            <span v-if="props.item.shipped==true && props.item.delivered==false && props.item.cancelled==false" style="font-size:10px;padding:3px;background-color:orange;border-radius:5px;color:white">Shipped</span>
            <span v-if="props.item.cancelled==true" style="font-size:10px;padding:3px;background-color:red;border-radius:5px;color:white">Cancelled</span>
            <span v-if="props.item.delivered==true" style="font-size:10px;padding:3px;background-color:green;border-radius:5px;color:white">Delivered</span>
          </td>
          <td class="justify-left layout px-4">
            <v-tooltip top color="#212121">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="primary" class="mr-1" @click="onEdit(props.item)">visibility</v-icon>
                
              </template>
              <span>View Details</span>
            </v-tooltip>
          </td>
          
        </template>
        <v-alert
          v-slot:no-results
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
    </v-card>
            </v-flex>
        </v-layout>
    </div>
  </div>
</template>


<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      list: [],
      search: "",
      tableHeader: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Order ID", value: "orderCode" },
        { text: "Order Date", value: "date" },
        { text: "Total Amount", value: "totalPrice" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" }
      ]
    };
  },

  mounted() {
      this.getData();
  },
  methods: {
      getData() {
        this.axios
        .get(config.API + "Orders", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.list = res.data;
          this.getData();
        });
      },
    onEdit(item) {
      this.$router.push(`/orderDetail/${item.id}`);
    },

    onDelete(item) {
      // alert(item.id);
      if (confirm("You want to Cancel this order !!")) {
        this.axios
          .delete(config.API + `Orders/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Cancelled successfully");
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Mulish&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
</style>
<style lang="css" scoped>
.covid {
  font-family: 'Quicksand', sans-serif;
  font-size: 12px;
  font-weight: bold;
}
.hdr {
 font-size: 50px;
 color: #e0e0e0;
}
.hdr1 {
 color: #e0e0e0;
}
.txt {
 font-family: 'Mulish', sans-serif;
}
.txtt {
 font-family: 'Sora', sans-serif;
}
.lftsid {
  background-color: black !important;
  background-size: cover;
  box-shadow: none !important;
  border-radius: 0px !important;
  height: 350px;
}
.login-form {
  padding: 40px;
}
.bckcolor {
  background-image: url("../../assets/loginbg.jpg");
  background-size: cover;
}
.cursr {
  cursor: pointer;
}
.v-btn {
  margin-left: 0px;
}
.txt_dec:hover {
    text-decoration: underline !important;
}
.loginPage {
  background-size:cover
}
.call-button-container {
  margin: auto;
  width: 233px;
  height: 74px;
  vertical-align: middle;
  padding: 10px;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
</style>
